import { FC } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from '@carbon/react';
import {
  CLASS_NONE_LABEL,
  classLabel,
  COST_TABLE_HEADERS,
  formatCurrency,
  lineCost,
  type DraftLineItem,
} from './cost-utils';
import styles from './cost.module.scss';

interface Props {
  items: DraftLineItem[];
}

// ── Read-view bucket table (Carbon Table size="sm") ──
export const CostBucketTable: FC<Props> = ({ items }) => {
  if (items.length === 0) {
    return <p className={styles.emptyRow}>No cost line items.</p>;
  }
  return (
    <TableContainer className={styles.tableWrap}>
      <Table size="sm">
        <TableHead>
          <TableRow>
            {COST_TABLE_HEADERS.map((h) => (
              <TableHeader
                key={h.key}
                className={h.right ? styles.colRight : undefined}
              >
                {h.header}
              </TableHeader>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => {
            const total = lineCost(item);
            return (
              <TableRow key={item.key}>
                <TableCell>{item.code ?? '—'}</TableCell>
                <TableCell>{item.description || '—'}</TableCell>
                <TableCell>
                  {classLabel(item.costClass ?? CLASS_NONE_LABEL)}
                </TableCell>
                <TableCell>{item.category}</TableCell>
                <TableCell>{item.subCategory || '—'}</TableCell>
                <TableCell className={styles.colRight}>
                  {formatCurrency(item.costPerUnit)}
                </TableCell>
                <TableCell className={`${styles.colRight} ${styles.totalCell}`}>
                  {formatCurrency(total)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
